module.exports = __webpack_public_path__ + "static/img/zl.04171d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/homepage/zl.jpg
// module id = kJI+
// module chunks = 1